import { SHORTENER_URL_LENGTH } from '../Config/env';

export const getContentWithReplacedUrlsLength = content => {
  const urlPattern = /\b(?:https?|ftp|http):\/\/[a-z0-9-+&@#\/%?=~_|!:,.;]*[a-z0-9-+&@#\/%=~_|]/gim;
  const stub = '#'.repeat(SHORTENER_URL_LENGTH);
  return content.replace(urlPattern, stub).length;
}
